export const validateFlow = ({ nodes, edges, triggers, name }) => {
    const errors = [];

    // Metadata Validation
    if (!name.trim()) errors.push("Flow name is required");

    // Triggers Validation
    triggers.forEach((t, i) => {
        if (!t.pattern) errors.push(`Trigger #${i + 1} is missing pattern`);
        if (t.type === 'reply' && !t.source) errors.push(`Reply Trigger #${i + 1} missing source`);
    });

    // Node Validation
    const startNodes = nodes.filter(n => n.type === 'start');
    if (startNodes.length === 0) errors.push("Flow must have exactly one Start node");
    if (startNodes.length > 1) errors.push("Flow creates multiple Start nodes");

    // Connectivity Validation
    const nodeIds = new Set(nodes.map(n => n.id));
    const visited = new Set();

    // DFS from start node
    if (startNodes.length === 1) {
        const stack = [startNodes[0].id];
        while (stack.length > 0) {
            const current = stack.pop();
            if (visited.has(current)) continue;
            visited.add(current);

            const outgoingEdges = edges.filter(e => e.source === current);
            outgoingEdges.forEach(e => {
                if (nodeIds.has(e.target)) stack.push(e.target);
            });
        }

        // Check for unconnected nodes (islands)
        // Note: This assumes all nodes must be reachable from start.
        // If there are unreachable clusters, they are invalid 'unconnected nodes'.
        nodes.forEach(n => {
            if (!visited.has(n.id)) {
                errors.push(`Node '${n.data.label}' (${n.type}) is not connected to the Start node`);
            }
        });
    }

    // Edge and Config Validation
    nodes.forEach(n => {
        const outgoing = edges.filter(e => e.source === n.id);

        if (n.type === 'end' && outgoing.length > 0) {
            errors.push(`End node cannot have outgoing edges`);
        }

        if (n.type === 'wait_event') {
            if (outgoing.length === 0) {
                errors.push(`Wait Event node must have at least one outgoing edge`);
            }

            // Check config
            if (!n.data.config?.timeout_ms) errors.push(`Wait Node missing timeout`);
        }

        if (n.type === 'send_form') {
            const c = n.data.config || {};
            if (!c.flow_id || !c.body_text) errors.push(`Form Node missing required config`);
        }

        if (n.type === 'send_single_product_message') {
            const c = n.data.config || {};
            if (!c.product_retailer_id) errors.push(`Node '${n.data.label}' is missing Product Retailer ID / SKU`);
        }

        if (n.type === 'send_multi_product_message') {
            const c = n.data.config || {};
            if (!c.header_text || !c.body_text) errors.push(`Node '${n.data.label}' is missing Header or Body text`);
            if (!c.sections || c.sections.length === 0) errors.push(`Node '${n.data.label}' must have at least one section`);
        }

        if (n.type === 'send_product_carousel') {
            const c = n.data.config || {};
            if (!c.cards || c.cards.length < 2) errors.push(`Node '${n.data.label}' requires at least 2 cards`);
        }
    });

    edges.forEach(e => {
        if (e.data?.condition?.type === 'expression' && !e.data?.condition?.expression) {
            errors.push(`Edge from ${e.source} to ${e.target} has empty expression`);
        }
    });

    return {
        isValid: errors.length === 0,
        error: errors.join('\n')
    };
};
